import axios from 'axios';
  import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';

export class ClinicalDataService {
  constructor() {
    this.apiBase = API_BASE;
  }

  async getAuthHeaders() {
    const token = await getAuthToken();
    if (!token) {
      throw new Error('No authentication token available');
    }
    return { Authorization: `Bearer ${token}` };
  }

  async getPatientPrescriptions(patientId, encounterId = null, limit = 100) {
    try {
      const headers = await this.getAuthHeaders();
      const params = new URLSearchParams();
      if (encounterId) params.append('encounterId', encounterId);
      if (limit) params.append('limit', limit.toString());
      
      const queryString = params.toString();
      const url = `${this.apiBase}/patients/${patientId}/prescriptions${queryString ? '?' + queryString : ''}`;
      
      const response = await axios.get(url, { headers });
      return response.data.prescriptions || [];
    } catch (error) {
      console.error('Error fetching prescriptions:', error);
      throw new Error('Failed to fetch prescriptions');
    }
  }

  async getPatientProcedures(patientId, encounterId = null, limit = 100) {
    try {
      const headers = await this.getAuthHeaders();
      const params = new URLSearchParams();
      if (encounterId) params.append('encounterId', encounterId);
      if (limit) params.append('limit', limit.toString());
      
      const queryString = params.toString();
      const url = `${this.apiBase}/patients/${patientId}/procedures${queryString ? '?' + queryString : ''}`;
      
      const response = await axios.get(url, { headers });
      return response.data.procedures || [];
    } catch (error) {
      console.error('Error fetching procedures:', error);
      throw new Error('Failed to fetch procedures');
    }
  }
}

export default ClinicalDataService;
